/* Kasutam theme — header: mobile drawer, dropdown, sticky shadow */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var utils = window.Kasutam.utils;
    var drawer = document.getElementById('MobileDrawer');
    var openBtn = document.querySelector('[data-drawer-open]');

    if (openBtn && drawer) {
      openBtn.addEventListener('click', function () {
        utils.openOverlay(drawer, { trigger: openBtn });
      });
    }

    drawer &&
      drawer.querySelectorAll('[data-drawer-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          utils.closeOverlay(drawer);
        });
      });

    document.querySelectorAll('.header__dropdown').forEach(function (dropdown) {
      document.addEventListener('click', function (e) {
        if (!dropdown.contains(e.target)) dropdown.removeAttribute('open');
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') dropdown.removeAttribute('open');
      });
    });

    var header = document.querySelector('.header[data-sticky="true"]');
    if (header) {
      var onScroll = utils.debounce(function () {
        header.classList.toggle('is-stuck', window.scrollY > 4);
      }, 10);
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  });
})();
